import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceCategory} from './service-category.model';
import * as ServiceCategoryActions from './service-category.actions';

export const serviceCategoriesFeatureKey = 'serviceCategories';

export interface State extends EntityState<ServiceCategory> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceCategory> = createEntityAdapter<ServiceCategory>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceCategoryActions.addServiceCategory,
    (state, action) => adapter.addOne(action.serviceCategory, state)
  ),
  on(ServiceCategoryActions.upsertServiceCategory,
    (state, action) => adapter.upsertOne(action.serviceCategory, state)
  ),
  on(ServiceCategoryActions.addServiceCategorys,
    (state, action) => adapter.addMany(action.serviceCategorys, state)
  ),
  on(ServiceCategoryActions.upsertServiceCategorys,
    (state, action) => adapter.upsertMany(action.serviceCategorys, state)
  ),
  on(ServiceCategoryActions.updateServiceCategory,
    (state, action) => adapter.updateOne(action.serviceCategory, state)
  ),
  on(ServiceCategoryActions.updateServiceCategorys,
    (state, action) => adapter.updateMany(action.serviceCategorys, state)
  ),
  on(ServiceCategoryActions.deleteServiceCategory,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceCategoryActions.deleteServiceCategorys,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceCategoryActions.loadServiceCategorys,
    (state, action) => adapter.setAll(action.serviceCategorys, state)
  ),
  on(ServiceCategoryActions.clearServiceCategorys,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
